import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar el abandono",
    opening: localizedGenderNode(
      [
      "Hoy no intento entenderlo todo.",
      "Solo noto la sensación de abandono.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento entenderlo todo.",
      "Solo noto la sensación de abandono.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se siente más la sensación de abandono?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo se siente más la sensación de abandono?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar ya es el comienzo de la conexión."
    ],
      [
      "Notar ya es el comienzo de la conexión."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Qué me falta",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que faltó entonces.",
      "Sin culpa.",
      "Solo ver."
    ],
      [
      "Hoy noto lo que faltó entonces.",
      "Sin culpa.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesitaba y no recibí?",
      "¿Qué sigo pidiendo hoy?",
      "¿Qué me cuesta pedir a otros?"
    ],
      [
      "¿Qué necesitaba y no recibí?",
      "¿Qué sigo pidiendo hoy?",
      "¿Qué me cuesta pedir a otros?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una falta pequeña explica mucho."
    ],
      [
      "Una falta pequeña explica mucho."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre lo que falta.",
      "escribir una palabra sobre lo que falta."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Cómo se quedó en mí",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que se quedó en mí desde entonces.",
      "Sin juicio.",
      "Solo verdad."
    ],
      [
      "Hoy noto lo que se quedó en mí desde entonces.",
      "Sin juicio.",
      "Solo verdad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo me afecta hoy?",
      "¿Dónde lo siento en las relaciones?",
      "¿Qué intento proteger?"
    ],
      [
      "¿Cómo me afecta hoy?",
      "¿Dónde lo siento en las relaciones?",
      "¿Qué intento proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo que se quedó en mí pide suavidad."
    ],
      [
      "Lo que se quedó en mí pide suavidad."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La parte que se siente sola",
    opening: localizedGenderNode(
      [
      "Hoy noto la parte en mí que se siente sola.",
      "No para arreglarla.",
      "Solo estar con ella."
    ],
      [
      "Hoy noto la parte en mí que se siente sola.",
      "No para arreglarla.",
      "Solo estar con ella."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde se sienta en mí?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ],
      [
      "¿Dónde se sienta en mí?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Estar con ella un momento ya es un cambio pequeño."
    ],
      [
      "Estar con ella un momento ya es un cambio pequeño."
    ]
    ),
    action: localizedGenderNode(
      "poner una mano en el corazón y respirar.",
      "poner una mano en el corazón y respirar."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo a apoyarme",
    opening: localizedGenderNode(
      [
      "Hoy observo el miedo a apoyarme.",
      "No para pelear.",
      "Solo reconocer."
    ],
      [
      "Hoy observo el miedo a apoyarme.",
      "No para pelear.",
      "Solo reconocer."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De qué tengo miedo cuando me apoyo?",
      "¿Qué creo que pasará?",
      "¿Cómo me protege este miedo?"
    ],
      [
      "¿De qué tengo miedo cuando me apoyo?",
      "¿Qué creo que pasará?",
      "¿Cómo me protege este miedo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo a apoyarme es un intento de protegerme."
    ],
      [
      "El miedo a apoyarme es un intento de protegerme."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Una petición pequeña de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición pequeña de seguridad.",
      "No grande.",
      "Pequeña."
    ],
      [
      "Hoy formulo una petición pequeña de seguridad.",
      "No grande.",
      "Pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me da una pequeña sensación de seguridad?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué me da una pequeña sensación de seguridad?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede calmar el corazón."
    ],
      [
      "Una petición puede calmar el corazón."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un pequeño momento de cercanía",
    opening: localizedGenderNode(
      [
      "Hoy busco un pequeño momento de cercanía segura.",
      "No mucho.",
      "Solo un poco."
    ],
      [
      "Hoy busco un pequeño momento de cercanía segura.",
      "No mucho.",
      "Solo un poco."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo tuve cercanía segura recientemente?",
      "¿Qué permitió que ocurriera?",
      "¿Qué podría invitar otro momento así?"
    ],
      [
      "¿Cuándo tuve cercanía segura recientemente?",
      "¿Qué permitió que ocurriera?",
      "¿Qué podría invitar otro momento así?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento pequeño cambia el rumbo."
    ],
      [
      "Un momento pequeño cambia el rumbo."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un límite que me protege",
    opening: localizedGenderNode(
      [
      "Hoy observo un límite pequeño que me protege.",
      "No para alejarme.",
      "Solo proteger."
    ],
      [
      "Hoy observo un límite pequeño que me protege.",
      "No para alejarme.",
      "Solo proteger."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento los hombros."
    ],
      [
      "Respiro despacio.",
      "Siento los hombros."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde doy demasiado?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ],
      [
      "¿Dónde doy demasiado?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño protege el corazón."
    ],
      [
      "Un límite pequeño protege el corazón."
    ]
    ),
    action: localizedGenderNode(
      "una frase de límite para mí.",
      "una frase de límite para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Quedarme conmigo",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme conmigo cuando sube el abandono.",
      "No huir.",
      "Solo estar."
    ],
      [
      "Hoy practico quedarme conmigo cuando sube el abandono.",
      "No huir.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ],
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Quedarme conmigo es un pequeño ancla."
    ],
      [
      "Quedarme conmigo es un pequeño ancla."
    ]
    ),
    action: localizedGenderNode(
      "una respiración cada vez que suba la sensación.",
      "una respiración cada vez que suba la sensación."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición clara",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición clara para mí.",
      "No grande.",
      "Clara."
    ],
      [
      "Hoy formulo una petición clara para mí.",
      "No grande.",
      "Clara."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito ahora para sentirme seguro/a?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué necesito ahora para sentirme seguro/a?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición clara puede calmarme."
    ],
      [
      "Una petición clara puede calmarme."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un valor que me sostiene",
    opening: localizedGenderNode(
      [
      "Hoy busco un valor que me sostiene.",
      "Pequeño.",
      "Pero verdadero."
    ],
      [
      "Hoy busco un valor que me sostiene.",
      "Pequeño.",
      "Pero verdadero."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor me importa dentro de un vínculo?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ],
      [
      "¿Qué valor me importa dentro de un vínculo?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor es un hilo de estabilidad."
    ],
      [
      "Un valor es un hilo de estabilidad."
    ]
    ),
    action: localizedGenderNode(
      "una palabra que exprese ese valor.",
      "una palabra que exprese ese valor."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Escuchar mi necesidad",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi necesidad.",
      "No para apartarla.",
      "Solo escucharla."
    ],
      [
      "Hoy escucho mi necesidad.",
      "No para apartarla.",
      "Solo escucharla."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el abdomen."
    ],
      [
      "Respiro despacio.",
      "Siento el abdomen."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es la necesidad más viva en mí ahora?",
      "¿Cómo suena en palabras simples?",
      "¿Qué podría darle un pequeño lugar?"
    ],
      [
      "¿Cuál es la necesidad más viva en mí ahora?",
      "¿Cómo suena en palabras simples?",
      "¿Qué podría darle un pequeño lugar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Escuchar la necesidad ya es un cambio."
    ],
      [
      "Escuchar la necesidad ya es un cambio."
    ]
    ),
    action: localizedGenderNode(
      "escribir la necesidad en una palabra.",
      "escribir la necesidad en una palabra."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de seguridad.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de seguridad.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para acercarme."
    ],
      [
      "Un paso pequeño es suficiente para acercarme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a la seguridad.",
      "Cuando me asusto.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a la seguridad.",
      "Cuando me asusto.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre este abandono?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre este abandono?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo sentirme abandonado/a y aun así quedarme conmigo."
    ],
      [
      "Puedo sentirme abandonado/a y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const feelingOfAbandonmentParentsAreEmotionallyPhysicallyUnavailableBlueprintEs = buildNormalizedPilotBlueprint({
  id: "feeling_of_abandonment_parents_are_emotionally_physically_unavailable_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "feeling_of_abandonment_parents_are_emotionally_physically_unavailable",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "תחושת נטישה (הורים לא זמינים רגשית / פיזית)",
    en: "Feeling of abandonment (parents emotionally/physically unavailable)",
    es: "Sensación de abandono (padres no disponibles emocional o físicamente)",
  },
  days,
});

export default feelingOfAbandonmentParentsAreEmotionallyPhysicallyUnavailableBlueprintEs;
